/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShortcodeDetail } from '../models/ShortcodeDetail';
import type { ShortCodesWithWorkflowInfo } from '../models/ShortCodesWithWorkflowInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ShortcodeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all the short codes related to one workflow definition
     * @param orgGuid
     * @param workflowGuid
     * @returns ShortCodesWithWorkflowInfo OK
     * @throws ApiError
     */
    public getShortcodesAsync(
        orgGuid: string,
        workflowGuid: string,
    ): CancelablePromise<ShortCodesWithWorkflowInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Shortcode/{orgGuid}/{workflowGuid}/GetShortcodesAsync',
            path: {
                'orgGuid': orgGuid,
                'workflowGuid': workflowGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Receive a shortcode and add it to the database.
     * If the shortcode already exists, it will be updated.
     * Otherwise, generate a unique shortcode and create a new record
     * @param requestBody
     * @returns ShortcodeDetail OK
     * @throws ApiError
     */
    public addUpdateShortcode(
        requestBody?: ShortcodeDetail,
    ): CancelablePromise<ShortcodeDetail> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Shortcode/AddUpdateShortcode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Generate a public link for a workflow
     * @param orgGuid
     * @param code
     * @returns string OK
     * @throws ApiError
     */
    public deleteShortcode(
        orgGuid: string,
        code: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Shortcode/{orgGuid}/{code}/DeleteShortcode',
            path: {
                'orgGuid': orgGuid,
                'code': code,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
